module.exports = __webpack_public_path__ + "img/pattern-3.bf46d773.svg";